import React, { useState, useEffect } from 'react';
import Video from 'twilio-video';
import Participant from './../participant/participant';
import NavBarComponent from "../../navBar/navBar";

const Room = ({ roomName, token, handleLogout }) => {
    const [room, setRoom] = useState(null);
    const [participants, setParticipants] = useState([]);

    const remoteParticipants = participants.map(participant => (
        <Participant key={participant.sid} participant={participant} />
      ));

      useEffect(() => {
        const participantConnected = participant => {
          setParticipants(prevParticipants => [...prevParticipants, participant]);
        };
        const participantDisconnected = participant => {
          setParticipants(prevParticipants =>
            prevParticipants.filter(p => p !== participant)
          );
        };
        Video.connect(token, {
          name: roomName
        }).then(room => {
          setRoom(room);
          room.on('participantConnected', participantConnected);
          room.on('participantDisconnected', participantDisconnected);
          room.participants.forEach(participantConnected);
        });

        return () => {
            setRoom(currentRoom => {
              if (currentRoom && currentRoom.localParticipant.state === 'connected') {
                currentRoom.localParticipant.tracks.forEach(function(trackPublication) {
                  trackPublication.track.stop();
                });
                currentRoom.disconnect();
                return null;
              } else {
                return currentRoom;
              }
            });
          };
      }, [roomName, token]);

      return (
        
        <div className="room">
          <NavBarComponent />
          <h2 className="room-name">{roomName}</h2>
          <button className="leave-room-btn" onClick={handleLogout}>Leave Room</button>
          {/* <button className="mute-btn" onClick={handleMute}>Mute</button> */}
          <div className="local-participant">
            {room ? (
                        <Participant
                        key={room.localParticipant.sid}
                        participant={room.localParticipant}
                      />
            ) : (
              ''
            )}
          </div>
          <h3>Remote Participants</h3>
          <div className="remote-participants">{remoteParticipants}</div>
        </div>
      );

    
};

export default Room;